export enum TypeSensor{
    OCR = 0,
    ACCELEROMETER = 1,
    LINEAR_ACCELERATION = 10,
    MAGNETIC_FIELD = 2,
    LIGHT = 5,
    PRESSURE = 6
  }
